import React, {Component} from 'react';
import {Card} from 'react-bootstrap';
import ResetPasswordForm from './Forms/ResetPassword/ResetPasswordForm';
import '../../../assets/sass/pages/auth/reset-password.scss';

class ResetPassword extends Component {

    render() {
        return (
            <Card className="reset-password">
                <h1 className="text-center">Set New Passsword</h1>
                <ResetPasswordForm/>
            </Card>
        )
    }
}

export default ResetPassword;
